// extracted by mini-css-extract-plugin
export default {"productGallery":"gH-z","inQuickShop":"hH-z"};